<template>
  <div class="slogan" :class="{ whitetext: White }">
    <div class="blackline"></div>
    <div class="container">
      <!--<div class="logo"></div>-->
      <div class="subtitle">A world without fear of cancer</div>
      <div class="text">
        瓦里安為世界領導品牌。為癌症提供創新科技及解決方案，以創造一個無懼癌症的世界為願景!
      </div>
      <div
        v-show="Slogan.one"
        class="Sarea"
        :class="{
          'animated fadeInLeft fast': Slogan.one,
          'animated fadeOutRight faster': !Slogan.one
        }"
      >
        <div class="title">關於我們</div>
        <div class="text">
          瓦里安致力於提升癌症照護全流程，透過優化病患體驗、提供更個人化的照護、簡化臨床流程，以及推動創新技術應用，協助醫療團隊提升治療成果，邁向無懼癌症的未來。
        </div>
      </div>
      <div
        v-show="Slogan.two"
        class="Sarea"
        :class="{
          'animated fadeInLeft fast': Slogan.two,
          'animated fadeOutRight faster': !Slogan.two
        }"
      >
        <div class="title">放射線治療</div>
        <div class="text">
          有效遏阻癌細胞成長與分裂，運用高能量之游離輻射破壞癌細胞，防止癌細胞生長與分裂，達到控制癌症之目的。
        </div>
      </div>
      <div
        v-show="Slogan.three"
        class="Sarea"
        :class="{
          'animated fadeInLeft fast': Slogan.three,
          'animated fadeOutRight faster': !Slogan.three
        }"
      >
        <div class="title">精準放射治療</div>
        <div class="text">
          結合高品質影像與AI人工智慧精準鎖定鎖定腫瘤，減少對正常器官的傷害。
        </div>
      </div>
      <div
        v-show="Slogan.four"
        class="Sarea"
        :class="{
          'animated fadeInLeft fast': Slogan.four,
          'animated fadeOutRight faster': !Slogan.four
        }"
      >
        <div class="title">適應性治療</div>
        <div class="text">
          依據腫瘤變化即時調整治療計畫，讓每次治療都更貼近患者需求，提升精準度與治療效果。
        </div>
      </div>
      <div
        v-show="Slogan.five"
        class="Sarea"
        :class="{
          'animated fadeInLeft fast': Slogan.five,
          'animated fadeOutRight faster': !Slogan.five
        }"
      >
        <div class="title">質子治療</div>
        <div class="text">
          瓦里安ProBeam<sup>®</sup>360°系統提供360度空間角度解決方案及3D影像重
          建技術，同時搭配最新強度調控質子治療技術，可依據腫瘤形狀進行塑造，為精準醫療更上一層樓。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 顯示順序：0 瓦里安介紹 / 1 放射治療 / 2 精準放射治療 / 3 適應性治療 / 4 質子治療
const SLOGANKEYS = ["one", "two", "three", "four", "five"];

export default {
  name: "HelloWorld",
  props: {
    Target: Number,
    White: Boolean
  },
  data() {
    return {
      Slogan: {
        one: false,
        two: false,
        three: false,
        four: false,
        five: false
      }
    };
  },
  watch: {
    Target: function() {
      this.TargetSet(this.Target);
    }
  },
  mounted() {
    this.TargetSet(this.Target);
  },
  methods: {
    TargetSet(t) {
      SLOGANKEYS.forEach((k, i) => {
        this.Slogan[k] = i === t;
      });
    }
  }
};
</script>

<style scoped lang="scss">
/* 由 Home 依底圖亮度自動判斷後傳入 */
.whitetext,
.whitetext .container {
  color: #fff;
}
.whitetext .blackline {
  background-color: #fff;
}

.title {
  margin-top: 30px;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 3rem;
}
.Sarea {
  position: absolute;
}

.blackline {
  width: 3px;
  height: 180px;
  float: left;
  background-color: black;
}

.container {
  color: black;

  margin-left: 30px;
}

.subtitle {
  margin-top: 10px;
  font-size: 2.2rem;
}

.text {
  text-align: justify;
  width: 550px;
  font-size: 1.2rem;
}

.logo {
  background-image: url("../assets/logo.png");
  background-position: left;
  background-size: 100%;
  background-repeat: no-repeat;
  width: 300px;
  height: 60px;
}

.slogan {
  /*background-color: black;*/
  text-align: left;
  margin-top: 200px;
  margin-left: 80px;

  position: absolute;
}
</style>
